/**
 * Видаляє HTML теги з тексту
 */
export const stripHtml = (html: string): string => {
  if (!html) return "";
  
  // Якщо document доступний (браузер), використовуємо DOM
  if (typeof document !== "undefined") {
    const tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  }
  
  // Fallback: видаляємо HTML теги через regex
  return html.replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").trim();
};
